import { IBounds } from "./Bounds.interface";
import type { IOverlayFill } from "./Overlay.interface";

interface IStudioElementBase {
  id: string;
  label: string;
  bounds: IBounds;
  active: boolean;
}

export enum EStudioElementType {
  TEXT = "text",
}

interface IStudioText extends IStudioElementBase {
  type: EStudioElementType.TEXT;
  options: {
    text: string;

    fontFamily?: string;
    fontSize?: string;
    fontColor?: string;
    /**
     * Optional gradient text fill. When set, takes precedence over `fontColor`
     * in renderers that support it (DOM via background-clip:text, Pixi via
     * FillGradient). Solid `kind: "solid"` is treated as a `fontColor`
     * fallback. Used by scene templates whose authored design relied on a
     * paint-server gradient (e.g. the vaporwave + synthwave chrome
     * headlines) — preserves the visual without baking the text into the bg.
     */
    fontGradient?: IOverlayFill;
    backgroundColor?: string;

    bold: boolean;
    italic: boolean;
    underline?: boolean;
    strike?: boolean;
    textAlign?: "left" | "center" | "right";
    lineHeight?: number;
    wordSpacing?: number;
  };
}

export type IStudioElement = IStudioText;
